<template>
  <div class="vendedores-wrapper" id="vendedores">
    <section class="vendedores-hero">
      <div class="bb-container">
        <div class="vendedores-hero__content">
          <div class="vendedores-hero__info">
            <div class="vendedores-hero__pretitulo vendedores-gradient">
              HelloWish Partners
            </div>
            <div class="vendedores-hero__titulo">
              Conecta tu marca con el proceso de compra de tus futuros clientes
            </div>
            <div class="vendedores-hero__descripcion">
              Haz que tu marca acompañe a tus futuros clientes mientras descubren,
              comparten y compran su próximo favorito.
            </div>
            <div class="vendedores-hero__actions">
              <a class="button button--accent button--lg" href="#vendedores-form">
                Solicitar información<i class="ml-2 uil uil-angle-right-b"></i>
              </a>
              <a class="link link--bold link--underline" href="#vendedores-planes">
                Ver planes
              </a>
            </div>
          </div>
          <div class="vendedores-hero__thumb">
            <img
              src="../../assets/img/covers/cover-vendedores-phone-mockups.webp"
              alt="Mockups de la app HelloWish: lista, ofertas de marcas y detalle de producto"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="vendedores-stats">
      <div class="bb-container">
        <div class="vendedores-stats__titulo">Líderes en España desde 2021</div>
        <div class="vendedores-stats__cards">
          <div class="vendedores-stats__card">
            <div class="vendedores-stats__card-num">+150.000</div>
            <div class="vendedores-stats__card-desc">usuarios</div>
          </div>
          <div class="vendedores-stats__card">
            <div class="vendedores-stats__card-num">30M€</div>
            <div class="vendedores-stats__card-desc">en productos intermediados</div>
          </div>
          <div class="vendedores-stats__card">
            <div class="vendedores-stats__card-num">+6</div>
            <div class="vendedores-stats__card-desc">países en Europa</div>
          </div>
          <div class="vendedores-stats__card">
            <div class="vendedores-stats__card-num">
              4,8
              <img src="../../assets/img/ico/ico-star-fill.svg" alt="" class="vendedores-stats__star" />
            </div>
            <div class="vendedores-stats__card-desc">en las stores · NPS = 90</div>
          </div>
        </div>
      </div>
    </section>

    <section class="vendedores-why">
      <div class="bb-container">
        <div class="vendedores-why__titulos">
          <div class="vendedores-why__titulo">
            ¿Por qué promocionarte en <span class="vendedores-gradient">HelloWish</span>?
          </div>
          <div class="vendedores-why__descripcion">
            HelloWish conecta tu marca con el "momento regalo". Un usuario escoge qué
            quiere para una ocasión especial y comparte sus deseos con su círculo.
          </div>
        </div>
        <div class="vendedores-why__items">
          <div class="vendedores-why__item" v-for="item in whyItems" :key="item.titulo">
            <img :src="item.ico" alt="" width="56" height="56" />
            <div class="vendedores-why__item-titulo">{{ item.titulo }}</div>
            <div class="vendedores-why__item-descripcion" v-html="item.descripcion"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="vendedores-tools">
      <div class="bb-container">
        <div class="vendedores-tools__titulo">
          Las mejores herramientas para posicionarte
        </div>
        <div class="vendedores-tools__descripcion">
          Tu marca acompaña a los usuarios en cada paso hacia su siguiente favorito.
        </div>
        <div class="vendedores-tools__items">
          <div class="vendedores-tools__item" v-for="item in toolItems" :key="item.titulo">
            <div class="vendedores-tools__phone">
              <img :src="item.cover" :alt="item.titulo" loading="lazy" />
            </div>
            <div class="vendedores-tools__item-titulo">{{ item.titulo }}</div>
            <div class="vendedores-tools__item-descripcion">{{ item.descripcion }}</div>
          </div>
        </div>
      </div>
    </section>

    <section id="vendedores-planes" class="vendedores-planes">
      <div class="bb-container">
        <div class="vendedores-planes__titulos">
          <div class="vendedores-planes__titulo">Planes a la medida de tu marca</div>
          <div class="vendedores-planes__pill">
            Pruébalo fácilmente contratando un pack de 6 meses
          </div>
        </div>

        <div class="vendedores-planes__cards">
          <div class="plan-card">
            <div class="plan-card__titulo">Básico</div>
            <div class="plan-card__precio">
              <span class="plan-card__moneda">€</span>100
              <span class="plan-card__periodicidad">/mes</span>
            </div>
            <div class="plan-card__descripcion">
              Para estar presente donde tus clientes deciden.
            </div>
            <div class="plan-card__actions">
              <a class="button button--primary button--block" href="#vendedores-form">
                Solicitar información
              </a>
            </div>
            <div class="plan-card__items">
              <div class="plan-card__item">Presencia de marca reforzada</div>
              <div class="plan-card__item">
                Integración de productos (máx. 20 SKUs)
              </div>
              <div class="plan-card__item">Integración de ofertas</div>
              <div class="plan-card__item">Informes de rendimiento</div>
            </div>
          </div>

          <div class="plan-card plan-card--recomendado">
            <div class="plan-card__badge-row">
              <div class="plan-card__titulo">Plus</div>
              <div class="plan-card__badge">Recomendado</div>
            </div>
            <div class="plan-card__precio">
              <span class="plan-card__moneda">€</span>200
              <span class="plan-card__periodicidad">/mes</span>
            </div>
            <div class="plan-card__descripcion">
              Máxima visibilidad y todas las herramientas de promoción.
            </div>
            <div class="plan-card__actions">
              <a class="button button--primary button--block" href="#vendedores-form">
                Solicitar información
              </a>
            </div>
            <div class="plan-card__items">
              <div class="plan-card__item">Presencia de marca reforzada</div>
              <div class="plan-card__item">
                Integración de productos (máx. 50 SKUs)
              </div>
              <div class="plan-card__item">Integración de ofertas</div>
              <div class="plan-card__item">Promoción de productos estrella</div>
              <div class="plan-card__item">Presencia en plantillas</div>
              <div class="plan-card__item">Informes de rendimiento</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="vendedores-faq">
      <div class="bb-container bb-container--730">
        <div class="vendedores-faq__titulo">Preguntas frecuentes</div>
        <div class="accordion accordion--card">
          <accordionItem v-for="item in faqItems" :key="item.title">
            <template v-slot:title>{{ item.title }}</template>
            <template v-slot:content>{{ item.content }}</template>
          </accordionItem>
        </div>
      </div>
    </section>

    <section id="vendedores-form" class="vendedores-contacto">
      <div class="bb-container bb-container--lista">
        <div class="vendedores-contacto__content">
          <div class="vendedores-contacto__titulos">
            <div class="vendedores-contacto__titulo">
              Tus futuros clientes están creando su lista de deseos.
              <span class="vendedores-gradient">¿Tu marca está en ella?</span>
            </div>
            <div class="vendedores-contacto__pretitulo">
              Hablemos de tus objetivos con datos reales de tu marca y tu categoría en
              HelloWish.
            </div>
            <div class="vendedores-contacto__reassurance">
              <i class="uil uil-check-circle"></i> Respuesta en menos de 24h · Sin
              compromiso
            </div>
          </div>

          <div class="vendedores-contacto__form" v-if="!requestInfoSent">
            <div class="bb-form-fieldset">
              <InputText
                :disabled="requestInfoFormIsSaving"
                :errorLabel="companyError"
                :initialValue="empresa"
                @focus="companyError = ''"
                v-model="empresa"
                label="Empresa"
                placeholder="Empresa"
                required
              />
              <InputText
                :disabled="requestInfoFormIsSaving"
                :errorLabel="emailError"
                :initialValue="email"
                @focus="emailError = ''"
                v-model="email"
                label="Email"
                placeholder="Email"
                required
              />
              <InputText
                :disabled="requestInfoFormIsSaving"
                :initialValue="categoria"
                v-model="categoria"
                label="Categoría"
                placeholder="Ej. Puericultura, moda, hogar…"
              />
              <InputTextArea
                :disabled="requestInfoFormIsSaving"
                :errorLabel="messageError"
                :initialValue="mensaje"
                @focus="messageError = ''"
                v-model="mensaje"
                label="Mensaje"
                placeholder="Mensaje"
                :rows="5"
                :maxlength="256"
                required
              />
            </div>

            <div class="vendedores-contacto__form-actions">
              <bbButton :disabled="requestInfoFormIsSaving" label="Solicita información" class="button--primary" @click="requestInfo()"></bbButton>
            </div>

            <div class="vendedores-contacto__form-legal">
              Al enviar este formulario aceptas los
              <router-link :to="{ name: 'legal' }">términos y condiciones</router-link>
              y la
              <router-link :to="{ name: 'privacity' }">política de privacidad</router-link>.
            </div>
          </div>

          <div class="vendedores-contacto__success" v-else>
            <i class="uil uil-check-circle"></i>
            <div class="vendedores-contacto__success-title">
              {{ $t("sellers.thanksPage.title") }}
            </div>
            <div class="vendedores-contacto__success-content">
              {{ $t("sellers.thanksPage.content") }}
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import InputText from "../../components/forms/InputText.vue";
import InputTextArea from "../../components/forms/InputTextArea.vue";
import bbButton from "../../components/buttons/bbButton.vue";
import accordionItem from "../pages/components/accordionItem.vue";

export default {
  name: "vendedores",
  components: {
    InputText,
    InputTextArea,
    bbButton,
    accordionItem,
  },
  metaInfo() {
    return {
      title: "HelloWish para Vendedores",
      meta: [
        {
          name: "description",
          content:
            "Consigue más ventas y gana nuevos clientes con una lista de deseos multi-tienda integrada en tu ecommerce.",
        },
      ],
    };
  },
  data() {
    return {
      empresa: "",
      email: "",
      categoria: "",
      mensaje: "",
      companyError: "",
      emailError: "",
      messageError: "",
      requestInfoFormIsSaving: false,
      requestInfoSent: false,
      whyItems: [
        {
          ico: require("../../assets/img/ico/ico-vendedores-calendario.webp"),
          titulo: "Horizonte de compra claro",
          descripcion:
            'El <strong>90%</strong> de nuestras listas trabajan con una fecha real (un nacimiento, una boda, un cumpleaños&hellip;).',
        },
        {
          ico: require("../../assets/img/ico/ico-vendedores-diana.webp"),
          titulo: "Audiencia cualificada y con alta intención de compra",
          descripcion:
            'Una comunidad activamente explorando y decidiendo. El <strong>43%</strong> de productos añadidos desencadenan un "Comprar" que redirige a la página del vendedor.',
        },
        {
          ico: require("../../assets/img/ico/ico-vendedores-telefono.webp"),
          titulo: "Acompañamiento",
          descripcion:
            "No es un impacto puntual, es presencia constante. Nuestra App acompaña a los usuarios durante todo el ciclo de decisión, visita tras visita.",
        },
        {
          ico: require("../../assets/img/ico/ico-vendedores-redes.webp"),
          titulo: "Alcance social",
          descripcion:
            "Cada lista de deseos llega de media a <strong>7,5 personas</strong>.",
        },
      ],
      toolItems: [
        {
          cover: require("../../assets/img/covers/screen-vendedores-catalogo.webp"),
          titulo: "Integración de productos",
          descripcion: "Haz que tus productos aparezcan en el catálogo virtual de HelloWish.",
        },
        {
          cover: require("../../assets/img/covers/screen-vendedores-estrella.webp"),
          titulo: "Promoción de productos estrella",
          descripcion:
            "Consigue una gran exposición para tus productos mostrándolos directamente en las listas de deseos.",
        },
        {
          cover: require("../../assets/img/covers/screen-vendedores-ofertas.webp"),
          titulo: "Integración de ofertas",
          descripcion: "Distribuye tus promociones directamente a los usuarios de HelloWish.",
        },
        {
          cover: require("../../assets/img/covers/screen-vendedores-informes.webp"),
          titulo: "Informes de rendimiento",
          descripcion:
            "Recibe métricas y análisis de resultados para medir el retorno de tu marca.",
        },
        {
          cover: require("../../assets/img/covers/screen-vendedores-marca.webp"),
          titulo: "Presencia de marca reforzada",
          descripcion:
            "Muestra el logotipo de tu marca en los productos añadidos desde tu tienda.",
        },
        {
          cover: require("../../assets/img/covers/screen-vendedores-plantillas.webp"),
          titulo: "Presencia en plantillas",
          descripcion:
            "Posiciona tu marca en las plantillas con las que los usuarios comienzan sus listas (posiciones limitadas por categoría).",
        },
      ],
      faqItems: [
        {
          title: "¿Hay algún periodo de contratación mínimo?",
          content:
            "El proceso de selección y compra usando una lista de deseos tiene un ciclo de vida de varios meses. Por eso tiene sentido una contratación acorde. Para facilitar la prueba, ofrecemos packs de contratación de 6 meses.",
        },
        {
          title: "¿Tenéis audiencia en mi categoría?",
          content:
            "En la llamada te explicaremos cuántos usuarios tienen ya productos de tu categoría e incluso de tu marca en sus listas de deseos.",
        },
        {
          title: "¿Cuánto trabajo me supone integrarlo?",
          content:
            "Muy poco. Nuestro equipo de integración se encarga de todo. Un caso típico tarda un par de días.",
        },
        {
          title: "¿En qué contexto aparece mi marca?",
          content:
            "Dentro de las listas de deseos de los propios usuarios: sin contenido de terceros, sin comentarios públicos, en un entorno premium.",
        },
        {
          title: "¿Cómo mido el retorno?",
          content:
            "Te proporcionaremos mensualmente las métricas que necesites para valorar tu retorno de inversión.",
        },
      ],
    };
  },
  computed: {
    requestInfoFormIsValid() {
      const {
        company,
        email,
        message,
      } = this.requestInfoPayload;

      return (
        company &&
        email &&
        message &&
        !this.companyError &&
        !this.emailError &&
        !this.messageError
      );
    },
    requestInfoPayload() {
      return {
        email: this.email?.trim() || "",
        company: this.empresa?.trim() || "",
        category: this.categoria?.trim() || "",
        message: this.mensaje?.trim() || "",
      };
    },
  },
  methods: {
    validateRequestInfoForm() {
      const {
        email,
        company,
        message,
      } = this.requestInfoPayload;

      if (!company) {
        this.companyError = this.$t("generic.field_is_required", this.lang);
      }
      if (!email) {
        this.emailError = this.$t("generic.field_is_required", this.lang);
      } else if (!this.$utils.validateEmail(email)) {
        this.emailError = this.$t("login.invalidEmailFormat", this.lang);
      }
      if (!message) {
        this.messageError = this.$t("generic.field_is_required", this.lang);
      }

      return this.requestInfoFormIsValid;
    },
    async requestInfo() {
      this.requestInfoFormIsSaving = true;

      try {
        if (!this.validateRequestInfoForm()) {
          return;
        }

        await this.$store.dispatch("sellerRequestInfo", this.requestInfoPayload);

        this.clearRequestInfoForm();

        this.requestInfoSent = true;
      } finally {
        this.requestInfoFormIsSaving = false;
      }
    },
    clearRequestInfoForm() {
      this.email = "";
      this.empresa = "";
      this.categoria = "";
      this.mensaje = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
